export default {"src":"/_next/static/media/search-drawer-empty-state.6eb0ac90.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};